import moment from 'moment';
import { Button } from 'primereact/button';
import React, { useRef, useState, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
import API from '../../Helper/server/API';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RESORT_LOGO_PATH, RESORT_NAME_AR, RESORT_NAME_EN, RESORT_WEBSITE } from '../../Helper/user';
import { View_active_bracelet, View_created_at, View_Img_bracelet, View_rule_type } from '../../constants/dataView';
import { _endPoints } from '../../Helper/links';
import QRCode from "react-qr-code";
import InvoiceFooter from '../../bookings/invoice/FooterInvoice';
import { Skeleton } from 'primereact/skeleton';

function ServiceReceiptMini({ bookingData, customerData, reservationData, props, state }) {
    const componentRef = useRef();
    const buttonRef = useRef();
    const toast = useRef(null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [bracelets, setBracelets] = useState([]);
    const [braceletInput, setBraceletInput] = useState('');
    const [replaceDialogVisible, setReplaceDialogVisible] = useState(false);
    const [braceletToReplace, setBraceletToReplace] = useState(null);
    const [newBraceletInput, setNewBraceletInput] = useState('');
    const [loading_get_bracelets, setLoading_get_bracelets] = useState(true);
    // useEffect(() => {
    //     getBracelet();
    // },);
    const [loading, setLoading] = useState(false);
    const getBracelet = () => {
        setLoading_get_bracelets(true);
        API.get(`web/API/reservationes/services/get_bracelets.php?id_reservation=${reservationData.ID_reservation}`)
            .then(res => {
                if (res && res.success) {
                    setBracelets(res.data);
                }
            })
            .finally(() => {
                setLoading_get_bracelets(false);
            });

    }
    const [loading_set_bracelet, setLoading_set_bracelet] = useState(false);
    const handleAddBracelet = () => {
        if (!braceletInput.trim()) {
            toast.current.show({ severity: 'warn', summary: 'تنبيه', detail: 'يرجى إدخال رقم السوار', life: 3000 });
            return;
        }
        setLoading_set_bracelet(true);
        API.post('web/API/reservationes/services/add_bracelets.php', {
            id_reservation: reservationData.ID_reservation,
            bracelets: [braceletInput.trim()]
        }).then(res => {
            if (res && res.success) {
                toast.current.show({ severity: 'success', summary: 'نجاح', detail: res.msg, life: 3000 });
                setBraceletInput('');
                getBracelet();
                // API.get(`web/API/reservationes/services/get_bracelets.php?id_reservation=${reservationData.ID_reservation}`)
                //     .then(res2 => {
                //         if (res2 && res2.success) setBracelets(res2.data);
                //     });
            } else {
                setBraceletInput('');
                toast.current.show({ severity: 'error', summary: 'خطأ', detail: res?.msg || 'حدث خطأ', life: 3000 });
            }
        })
            .finally(() => {
                setLoading_set_bracelet(false);
            });

    };
    const handleReplaceBracelet = () => {
        if (!newBraceletInput.trim()) {
            toast.current.show({ severity: 'warn', summary: 'تنبيه', detail: 'يرجى إدخال رقم السوار الجديد', life: 3000 });
            return;
        }
        setLoading(true);
        setLoading_get_bracelets(true);
        API.post('web/API/reservationes/services/replace_bracelet.php', {
            id_bracelet: braceletToReplace.id,
            new_bracelet_number: newBraceletInput.trim()
        }).then(res => {
            if (res && res.success) {
                toast.current.show({ severity: 'success', summary: 'نجاح', detail: res.msg, life: 3000 });
                setReplaceDialogVisible(false);
                setNewBraceletInput('');
                getBracelet();
            } else {
                toast.current.show({ severity: 'error', summary: 'خطأ', detail: res?.msg || 'حدث خطأ', life: 3000 });
            }
        }).finally(() => {
            setLoading(false);
            setLoading_get_bracelets(false);
        });
    };

    const confirmReplaceBracelet = (bracelet) => {
        setBraceletToReplace(bracelet);
        setNewBraceletInput('');
        setReplaceDialogVisible(true);
    };


    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
            <div id="invoice" className="page page-content fade-in-up" dir="rtl" style={{ width: "80mm", border: "1px solid #1212125b", padding: "1rem", backgroundColor: "white" }} ref={componentRef} >
                <style>{`
                    @media print {
                        @page {
                            size: 80mm auto;
                            margin: 0;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                            background: white;
                        }
                        #invoice {
                            width: 80mm !important;
                            max-width: 80mm !important;
                            border: none !important;
                            padding: 5mm 2mm !important;
                            margin: 0 !important;
                            box-shadow: none !important;
                        }
                    }
                `}</style>
                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    <img src={_endPoints.resorts.images + RESORT_LOGO_PATH} alt="Logo" style={{ width: "50%" }} />
                    <h3 style={{ margin: "0", fontSize: "20px", fontWeight: "bold" }}>{RESORT_NAME_AR} - {RESORT_NAME_EN} </h3>
                    {
                        state == 'delete' ?
                            <p style={{ margin: "5px 0", fontSize: "15px" }}>فاتورة إسترجاع </p>
                            :
                            <p style={{ margin: "5px 0", fontSize: "15px" }}>فاتورة حجز خدمة</p>
                    }

                </div>

                <hr style={{ borderTop: "1px dashed #000", margin: "10px 0" }} />

                <div style={{ fontSize: "14px", marginBottom: "10px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "20%" }}>رقم الحجز:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{reservationData?.ID_reservation || "-"}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "20%" }}>تاريخ الفاتورة:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{moment().format('HH:mm') + ' / ' + moment().format('YYYY-MM-DD')}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "20%" }}>العميل:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{customerData?.visitor_name || "-"}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "20%" }}>الهاتف:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{customerData?.phone_number || "-"}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <hr style={{ borderTop: "1px dashed #000", margin: "10px 0" }} />

                <div style={{ fontSize: "15px", fontWeight: "bold", textAlign: "center", marginBottom: "10px" }}>
                    {bookingData?.service_name_ar}
                </div>

                <div style={{ fontSize: "13px", marginBottom: "10px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "20%" }}>تاريخ الدخول:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{moment(reservationData?.date_check_in).format('YYYY-MM-DD')}</td>
                            </tr>
                            <tr>
                                <td style={{ width: "20%" }}>إجمالي الأشخاص:</td>
                                <td style={{ fontWeight: "bold", width: "30%" }}>{reservationData?.number_people ? reservationData?.number_people + ' شخص' : '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {
                    reservationData?.reservation_services?.length ? (
                        <>
                            <hr style={{ borderTop: "1px dashed #000", margin: "0px 0" }} />
                            <table style={{ width: "100%", fontSize: "12px", marginBottom: "10px", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ borderBottom: "1px dashed #000" }}>
                                        <th style={{ textAlign: "right", padding: "3px 0", fontSize: "14px" }}>التفاصيل</th>
                                        <th style={{ textAlign: "center", padding: "3px 0", fontSize: "14px" }}>العمر</th>

                                        <th style={{ textAlign: "center", padding: "3px 0", fontSize: "14px" }}>العدد</th>
                                        <th style={{ textAlign: "left", padding: "3px 0", fontSize: "14px" }}>القيمة</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {reservationData?.reservation_services?.map((item, index) => {
                                        let extra_persons = Math.max(0, item?.persons * 1);
                                        if (extra_persons > 0) {
                                            return (
                                                <tr key={index}>
                                                    <td style={{ padding: "3px 0" }}>{View_rule_type(item)}</td>
                                                    <td style={{ textAlign: "center", padding: "3px 0" }}>من {item?.min_age} سنة الي {item?.max_age} سنة</td>
                                                    <td style={{ textAlign: "center", padding: "3px 0" }}>{item?.persons}</td>
                                                    <td style={{ textAlign: "left", padding: "3px 0" }}>{item?.total_price ? <>{item?.total_price} د.ل</> : '-'} </td>
                                                </tr>
                                            );
                                        }
                                        return null;
                                    })}
                                </tbody>
                            </table>
                        </>
                    ) : (
                        <></>
                    )}
                <hr style={{ borderTop: "1px dashed #000", margin: "0px 0" }} />

                <div style={{ fontSize: "16px", fontWeight: "bold", display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                    <span>الإجمالي:</span>
                    <span>{reservationData?.total_price.toLocaleString('en-US')} د.ل</span>
                </div>
                <div style={{ fontSize: "16px", fontWeight: "bold", display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                    <span>
                        {
                            state == 'delete' ?
                                'المبلغ المسترجع'
                                :
                                'المدفوع:'
                        }
                    </span>
                    <span>{reservationData?.total_paid.toLocaleString('en-US')} د.ل</span>
                </div>

                <hr></hr>

                <center>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", }}>
                        <div style={{ textAlign: "center", fontSize: "13px", fontWeight: "bold", marginTop: "auto", marginBottom: "auto", width: "40%" }}>
                            <p style={{ margin: "0" }}>نتمنى لكم وقتاً ممتعاً</p>
                            <p style={{ margin: "5px 0 0 0" }}>شكراً لزيارتكم</p>
                        </div>

                        <div style={{ textAlign: "left", fontSize: "13px", marginTop: "auto", marginBottom: "auto", width: "60%" }}>
                            <center>
                                <QRCode

                                    style={{ height: "auto", maxWidth: "50%", width: "30%" }}
                                    value={reservationData?.qrcode ?? RESORT_WEBSITE}
                                    viewBox={`0 0 256 256`}
                                />
                            </center>
                        </div>

                    </div>
                </center>
                {/* <InvoiceFooter /> */}
            </div>

            <div className="text-center mt-2">
                {/* <Button dir='ltr' severity='danger' className='ml-2' outlined type="button" label="إغلاق" icon='pi pi-times' onClick={() => { props?.hideDialog && props.hideDialog() }} /> */}
                <ReactToPrint
                    trigger={() => <Button dir='ltr' className='ml-2' severity='info' type="button" label="طبــاعة" icon='pi pi-print' outlined ref={buttonRef} />}
                    content={() => componentRef.current}
                />
                <Button dir='ltr' className='ml-2' severity='info' outlined type="button" label="أساور للزوار" icon='pi pi-users' onClick={() => {
                    getBracelet()
                    setDisplayDialog(true)
                }} />
            </div>

            <Dialog header="إدراج أساور للزوار" visible={displayDialog} style={{ width: '50vw' }} onHide={() => setDisplayDialog(false)} dir="rtl"
                footer={
                    <div className="p-fluid">
                        <center>
                            <Button label="إغلاق" severity='danger' outlined icon="pi pi-times pl-2" onClick={() => setDisplayDialog(false)} />
                        </center>
                    </div>
                }
            >
                <div className="p-fluid">
                    <Toast ref={toast} position="top-center" />
                    <div className="p-field mb-4 mt-2 flex justify-center gap-1">
                        <div className='row'>
                            <div className='col-10'>
                                <InputText
                                    value={braceletInput}
                                    onChange={(e) => setBraceletInput(e.target.value)}
                                    placeholder="أدخل رقم السوار"
                                    // onKeyPress={(e) => {
                                    //     if (e.key === 'Enter') handleAddBracelet();
                                    // }}
                                    autoFocus disabled={loading_set_bracelet}
                                />
                            </div>
                            <div className='col-2'>
                                <Button label="إضافة" icon="pi pi-plus" severity='success' outlined onClick={handleAddBracelet} loading={loading_set_bracelet} />
                            </div>
                        </div>
                    </div>

                    <center>
                        <table className='table w-full mb-0' style={{ border: "1px solid #dee2e6", backgroundColor: "#f8f9fa" }}>
                            <thead>
                                <tr >
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>الحجز</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>{reservationData?.ID_reservation}</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>تاريخ الدخول</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>{moment(reservationData?.date_check_in).format("YYYY-MM-DD")}</th>
                                </tr>
                                <tr >
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>العدد الأشخاص</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>{reservationData?.number_people}</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>المسجل</th>
                                    <th style={{ border: "1px solid #dee2e6", width: "25%" }}>{
                                        loading_get_bracelets ?
                                            <Skeleton width='5rem' style={{ display: "inline" }} ></Skeleton> :
                                            bracelets.length
                                    }</th>
                                </tr>
                            </thead>
                        </table>

                    </center>

                    {loading_get_bracelets ?

                        <DataTable value={[1, 2, 3]} emptyMessage={<center><p className='font-bold text-lg p-4'>لا توجد أساور مسجلة</p></center>}>
                            <Column header="#" body={<Skeleton></Skeleton>} style={{ width: '3%', textAlign: "right" }}></Column>
                            <Column field="bracelet_number" body={<Skeleton height='50px' width='100%'  ></Skeleton>} header="رقم السوار" style={{ width: '75%', textAlign: "right" }}></Column>
                            <Column field="active" body={<Skeleton ></Skeleton>} style={{ textAlign: "right", width: '5%' }}></Column>
                            {/* <Column field="created_at" body={<Skeleton ></Skeleton>} header="تاريخ الإضافة" style={{ textAlign: "right", width: '17%' }}></Column> */}
                            <Column field="action" header="إجراء" style={{ textAlign: "center", width: '10%' }}
                                body={(item) => (
                                    <Skeleton ></Skeleton>
                                )}
                            />
                        </DataTable>
                        :
                        <DataTable value={bracelets} emptyMessage={<center><p className='font-bold text-lg p-4'>لا توجد أساور مسجلة</p></center>}>
                            <Column field="bracelet_number" header="#" style={{ width: '3%', textAlign: "right" }}></Column>
                            <Column field="bracelet_number" body={View_Img_bracelet} header="رقم السوار" style={{ width: '75%', textAlign: "right" }}></Column>
                            <Column field="active" header="حالة" body={View_active_bracelet} style={{ textAlign: "right", width: '5%' }}></Column>

                            {/* <Column field="bracelet_number" header="رقم السوار" style={{ textAlign: "right" }}></Column> */}
                            {/* <Column field="created_at" body={View_created_at} header="تاريخ الإضافة" style={{ textAlign: "right", width: '17%' }}></Column> */}
                            <Column field="action" header="إجراء" style={{ textAlign: "center", width: '10%' }}
                                body={(item) => (
                                    <Button
                                        icon="pi pi-sync"
                                        tooltip="استبدال السوار"
                                        tooltipOptions={{ position: 'top' }}
                                        className="p-button-text p-button-warning"
                                        onClick={() => confirmReplaceBracelet(item)}
                                        disabled={loading}
                                    />
                                )}
                            />
                        </DataTable>
                    }
                </div>
            </Dialog>

            <Dialog header="استبدال سوار تالف أو مفقود" visible={replaceDialogVisible} style={{ width: '30vw' }} onHide={() => setReplaceDialogVisible(false)} dir="rtl">
                <div className="p-fluid">
                    <p>أنت تقوم باستبدال السوار القديم: <strong>{braceletToReplace?.bracelet_number}</strong></p>
                    <div className="p-field mb-4 mt-2">
                        <label>رقم السوار الجديد</label>
                        <InputText
                            value={newBraceletInput}
                            onChange={(e) => setNewBraceletInput(e.target.value)}
                            placeholder="أدخل رقم السوار الجديد هنا"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') handleReplaceBracelet();
                            }}
                            autoFocus
                            disabled={loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <Button label="إلغاء" severity='danger' outlined icon="pi pi-times" onClick={() => setReplaceDialogVisible(false)} className="p-button-text w-full" disabled={loading} />
                        </div>
                        <div className="col-6">
                            <Button label="استبدال السوار" severity='success' outlined icon="pi pi-check" onClick={handleReplaceBracelet} loading={loading} autoFocus />
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default ServiceReceiptMini;
